var React = require('react');

function PauseButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 7h-3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m7 0h-3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1"}));
}

PauseButton.defaultProps = {"id":"icon_pause","viewBox":"0 0 30 30"};

module.exports = PauseButton;

PauseButton.default = PauseButton;
